import { type FC } from 'react'
import { Box, Typography } from 'shared/ui'

import styles from './styles.module.scss'

export type IWidgetChatCardProps = {
  blockId: string
  title: string
  description: string
}

export const WidgetChatCard: FC<IWidgetChatCardProps> = ({ blockId, title, description }) => (
  <Box className={styles.block}>
    <div className={styles.blockId}>
      <Typography
        ariaLabel={`WidgetChat_${blockId}_blockId`}
        variant='body-sm-medium'
        color='var(--content-primary-primary)'
      >
        {blockId}
      </Typography>
    </div>
    <Typography ariaLabel={`WidgetChat_${blockId}_title`} variant='body-lg-medium'>
      {title}
    </Typography>
    <Typography
      ariaLabel={`WidgetChat_${blockId}_description`}
      variant='body-md-regular'
      color='var(--content-primary-secondary)'
    >
      {description}
    </Typography>
  </Box>
)
